import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'
import { getRequest, postRequest, patchRequest } from '@/plugins/api-axios'

@Mixin
export default class CompanyMixin extends Vue {
    url_company = process.env.VUE_APP_COMPANY_BASE_URL

    get headersmixins() {
        return {
            'Content-Type': 'application/vnd.api+json',
        }
    }

    companyName(id: string) {
        return this.$store.getters.company(id).attributes.displayName
            ? this.$store.getters.company(id).attributes.displayName
            : this.$store.getters.company(id).attributes.officialName
    }

    // COMPANY
    async getCompanies(params: any) {
        let url = `${this.url_company}/companies`
        let res = await getRequest(url, this.headersmixins, params)
        let companies: any = {}
        res.data.data.map((item: any) => {
            companies[item.id] = item
        })
        this.$store.commit('companies', { ...this.$store.getters.companies, ...companies })
        return res.data.data
    }

    async getCompany(id: string) {
        let url = `${this.url_company}/companies/${id}`
        let res = await getRequest(url, this.headersmixins)
        return res.data.data
    }

    async postCompany(params: any) {
        let url = `${this.url_company}/companies`
        let res = await postRequest(url, this.headersmixins, params)
        return res
    }

    async patchCompany(params: { updatedAt: string; company: any }) {
        let url = `${this.url_company}/companies/${params.company.id}`
        let res = await patchRequest(url, this.headersmixins, params.company)
        return res.data.data
    }
}
